import * as React from "react"
import { SolutionSection } from "../config/interfaces";

const MODIFIERCLASS: any = {
    Der: '',
    Izq: 'image-desc--left',
    Arr: 'image-desc--top'
}

const ANIMATION: any = {
    Der: 'fade-right',
    Izq: 'fade-left',
    Arr: 'fade-up'
}

export default ({ data }: { data: SolutionSection }) => {
    return (
        <div className={`image-desc${' ' + MODIFIERCLASS[data?.image_position]}`}>
            <section className="image-desc__body" data-aos={ANIMATION[data?.image_position]}>
                {data.desc && introductionFilter(data.desc)}
                <h2 className="image-desc__title">{data.title}</h2>
                <div className="image-desc__content" dangerouslySetInnerHTML={{ __html: data.desc.replace(/<p id="intro">.*<\/p>/g, '') }}></div>
            </section>
            {
                data.image && data.image?.url
                    ? (
                        <section className="image-desc__image" data-aos={ANIMATION[data?.image_position]}>
                            <img src={data.image?.url} alt={data.image?.alt} title={data.image?.alt} width='650' height='650' />
                        </section>
                    ) : null
            }

        </div >
    )
}

// filter introduction paragraph
const introductionFilter = (stringHtml: string) => { // data.desc
    const intro = stringHtml.match(/<p id="intro">.*<\/p>/g)
    if (intro) {
        return (
            <div className="image-desc__intro" dangerouslySetInnerHTML={{ __html: intro[0] }}></div>
        )
    }
}